import { CustomCheckbox, SelectOption } from "components/input/Input";
import {
  CustomDatePickerWrap,
  EllipsisTextColumn,
  FlexGrow,
  PageArticleWrap,
  PageHeaderTitleButtonStyle,
} from "components/layout/Layout";
import {
  OutlinePrimaryBtn,
  SolidPrimaryBtn,
  SolidPrimarySubBtn,
  SolidPrimaryWhiteBtn,
  SolidRedBtn,
} from "components/button/Button";
import { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import {
  ClassInfo,
  ClassQueryParams,
  ImageListType,
  ListResult,
  NotebookInfo,
  NotebookRequestType,
  StudentInfo,
  provinceInfo,
} from "type/type";
import ReactDatePicker from "react-datepicker";
import { getMonth, getYear } from "date-fns";
import { ko } from "date-fns/locale";
import {
  NoDataWithImageText,
  NoDataWithImageTextButton,
} from "components/NoDataComponent";
import {
  deleteNotebook,
  getClass,
  getFileOrigin,
  getNotebook,
  postNotebook,
  putNotebook,
  url,
} from "api/api";
import Loading from "components/Loading";
import {
  CURRENTYEAR, MONTHS, NoClassDataText,
  NoNotebookDataToParentText, NoStudentDataText, NoTeamClassDataText, NotebookType,
  ROLE_DIRECTOR, ROLE_TEACHER,
  aesCBCDecrypt, changeNotebookType, create_user_type_PARENT, create_user_type_TEACHER,
  ellipsisText, extractNumber,
  formattedDateHyphenYYYYMMDD, formattedDateYYYYMMDD, formattedSelectOption,
  getByteSize, getDayClassName, getNotebookImageUrl,
  patternDocFile, patternExclusionFile, patternImageFile,
  userClassSelectOption, userClassStudentSelectOption,
} from "utils/commonUtils";
import { DocIcon, colors } from "styles/global-styles";
import { Outlet, useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { DefaultModalComponent, ModalPropsInterface, ModalTitle, ModalType } from "components/ModalComponent";
import { ReactComponent as ErrorImage } from "assets/image/common/no-img.svg";
import refreshIcon from "assets/image/common/refresh.svg";
import { FlexWrapC, FlexWrapR, InputWrapR } from "components/common/CommonLayout";
import { RoundIcon } from "components/common/Icon";
import { useLoginUserInfo } from "../../redux/hook/useLoginUserInfo";
import { useRecoilValue } from "recoil";
import { holidayState, selectSiteIdState, userRoleState } from "styles/atoms";

const SelectFilterWrap = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  position: relative;

  input[type='text'] {
    width: 100%;
    cursor: pointer;
    &:disabled {
      cursor: default;
    }
  }
`;
const SelectOptionWrapContainer = styled(FlexWrapR)`
  align-items: center;
  position: absolute;
  top: 3rem;
  width: calc(100% - 2rem);
  right: 0;
  background-color: ${({theme}) => theme.rootWhite};
  border-radius: 0.25rem;
  border: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
  z-index: 3;
  overflow: hidden;
  height: 180px;
`;
const SelectWrapC = styled(FlexWrapC)`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 0.25rem;
`;
const SelectInputWrapR = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;
  padding: 0.25rem 0.5rem;
  justify-content: space-between;
  label {
    padding: 0.5rem;
    width: calc(100% - 1.25rem)
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      cursor: pointer;
    }
  }
  &:hover {
    background-color: ${colors.secondaryHover};
  }
`;

// 선생님께/학부모님께 active 부분
const NotebookTypeWrap = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
    font-size: 1rem;
    padding: 0.25rem;
    border-bottom: 2px solid transparent;
  }
  .note-count {
    padding: 0.25rem 0.5rem;
    border-radius: 50%;
    // 기본색상
    color: ${({theme}) => theme.newTheme.default.primary};
    background-color: ${({theme}) => theme.newTheme.default.secondary};
  }
  .active {
    // active 색상
    color: ${({theme}) => theme.newTheme.text.mainText};
    border-bottom: 2px solid ${({theme}) => theme.newTheme.text.mainText};
    .note-count {
      color: ${({theme}) => theme.newTheme.text.btnText_w};
      background-color: ${({theme}) => theme.newTheme.default.primary};
    }
  }
`;

const NotebookOneWrap = styled.div`
  // height: calc(100% - 2.5rem);
  height: 100%;
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  .list-table {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  .list-table-header {
    font-family: var(--font-nanumSquare-acB);
    position: sticky;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: ${({theme}) => theme.newTheme.table.tableHeadBg};
    color: ${({theme}) => theme.newTheme.table.tableHeadText};
    border-radius: 0.5rem;
    z-index: 1;

    > div {
      padding: 0.5rem 1rem;
      font-size: 1rem;
    }
  }
`;

const NotebookOne = styled.div`
  min-height: 3.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    &:nth-of-type(6) {
      word-break: auto-phrase;
    }
  }
  .thumbnail-wrap {
    img {
      width: 80px;
      height: 80px;
      object-fit: cover;
      aspect-ratio: 1 / 1;
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.newTheme.table.tableBodyHoverBg};
    cursor: pointer;
  }
`;

// 알림장 등록/수정 - 내용 및 사진 등록 부분분
const EditContentContainer = styled.div`
  height: 100%;
  display: grid;
  // grid-template-areas:
  //   "a b"
  //   "a c";
  grid-template-areas:
    "a b";
  grid-template-columns: 2fr 1fr;
  gap: 1rem;
  overflow: hidden;
`;
const EditArticle = styled.article`
  min-height: 16rem;
  height: 100%;
  background-color: ${({theme}) => theme.rootWhite};
  border-radius: 0.5rem;
  padding: 1rem 1.25rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &:first-of-type {
    grid-area: a;
  }
  
  .edit-article-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    p:first-of-type {
      display: flex;
      flex-direction: row;
      gap: 0.5rem;
    }
    .edit-article-header-title {
      color:${({theme}) => theme.newTheme.text.mainText};
      font-size: 1rem;
      font-weight: 600;
    }
  }
  .edit-article-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    input[type="text"] {
      width: 100%;
      height: 3.5rem;
      padding: 0 1.25rem;
      font-size: 1.25rem;
      background: none;
      border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
    }
    > div:last-of-type {
      height: 100%;
    }
    textarea {
      width: 100%;
      height: 100%;
      resize: none;
      border-radius: 0.5rem;
      padding: 1rem;
      border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
      font-size: 1rem;
      line-height: 1.25;

      &:focus-visible {
        outline: none;
      }
    }
  }
  .file-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .doc-wrap {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    overflow: auto;
  }
`;

const FileOneWrap = styled.div`
  width: calc((100% - 1.5rem) / 4);
  aspect-ratio: 1 / 1;
  border-radius: 0.5rem;
  border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .preview-image {
    height: 100%;
    aspect-ratio: 1 / 1;
    object-fit: contain;
  }
  .delete-preview-image {
    display: none;
    position: absolute;
    top: 1px;
    right: 1px;
  }
  &:hover {
    cursor: pointer;
    img:not(.cancel-icon),
    label {
      opacity: 0.7;
    }
    .delete-preview-image {
      display: block;
    }
  }
`;
const DocumentWrap = styled.div`
  padding: 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
`;

// 상세보기
const NotebookTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
  nav.notebook-title-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${({ theme }) => theme.newTheme.default.accent};
    }
  .notebook-main-title {
    font-size: 1.25rem;
    padding: 0.5rem 0;
    color: ${({ theme }) => theme.newTheme.default.text};
    font-weight: 600;
  }
`;

// 상세보기 - 파일이 있는 경우 파일 부분
export const DocFileWrap = styled.details`
  summary {
    display: flex;
    padding: 0.75rem;
    border-radius: 0.5rem;
    background-color: #f2f2f2;
    &:focus-visible {
      outline-color: ${({ theme }) => theme.newTheme.default.accent};
    }
  }
  > div {
    display: flex;
  }
  &[open] {
    border-radius: 0.5rem;
    background-color: #f2f2f2;
    > div:hover {
      background-color: #f7f7f7;
    }
  }
`;

// 상세보기 - 이미지가 있는 경우 이미지 부분
export const ImageFileWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  position: relative;

  .image-wrap {
    // width: 80%;
    // height: 80%;
    width: 350px;
    height: 350px;
    aspect-ratio: 1 / 1;
    position: relative;
    
    >div:not(.pagination) {
      position: relative;
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: none;
      &.show {
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }
    }

    div.pagination {
      position: absolute;
      bottom: 0.5rem;
      display: flex;
      width: 100%;
      justify-content: center;

      p {
        background-color: rgb(26 26 26 / 80%);
        padding: 0.25rem 0.5rem;
        border-radius: 0.5rem;
        color: ${({ theme }) => theme.rootWhite};
        padding: 0.25rem 0.5rem;
        border-radius: 0.5rem;
      }
    }
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  
  // 해상도에 따라 이미지 크기 키우기
  @media screen and (max-width: 1920px) {
    .image-wrap {
      // width: 50%;
      // height: 50%;
    }
  }
  .page-btn {
    cursor: pointer;
    &:hover {
      opacity: 0.6;
    }
    &.disabled {
      opacity: 0.3;
      cursor: default;
    }
  }
`;

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

const ZoomFrame = styled.div<{show: boolean, x: number, y: number}>`
  position: absolute;
  width: 100px;
  height: 100px;
  border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  background: rgba(255, 255, 255, 0.4);
  pointer-events: none;
  display: ${props => props.show ? 'block' : 'none'};
  left: ${props => props.x}px;
  top: ${props => props.y}px;
`;

const ZoomWindow = styled.div<{show: boolean, x: number, y: number, dx: number, dy: number}>`
  position: fixed;
  right: 1.25rem;
  top: 0;
  bottom: 40%;
  left: 0;
  right: 60%;
  margin: auto;
  width: 350px;
  height: 350px;
  border: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
  background-color: ${({theme}) => theme.newTheme.border.primaryBd};
  overflow: hidden;
  display: ${props => props.show ? 'block' : 'none'};
  z-index: 5;

  img {
    position: absolute;
    transform: scale(4);
    transform-origin: top left;
    left: ${props => -props.x * 4 + (props.dx * 4)}px;
    top: ${props => -props.y * 4 + (props.dy * 4)}px;
  }
`;

type NotebookQueryParams = {
  page: number;
  size: number;
  create_user_type: number;
  class_id: number;
  student_id: number;
  note_start_date: string;
  note_end_date: string;
};

type EditNotebookRequestType = {
  note_date: string;
  type: number;
  title: string;
  content: string;
  user_id: number;
  class_name: string;
  student_name: string;
  remove_file_id_list: number[];
};


type DetaileNotebookProps = {
  id: number;
  type: number;
  title: string;
  content: string;
  is_group: number;
  user_id: number;
  user_name: string;
  create_user_class_name: string;
  create_user_type: number;
  like_count: number;
  note_date: string;
  reg_date: string;
  update_date: string;
  file_list: [],
  student_name: string;
  class_name: string;
}

type FileListType = {
  file_name: string;
  file_path: string;
  file_size: number;
  id: number;
  mime_type: string;
  notebook_id: number;
  origin_file_name: string;
  reg_date: string;
};

// 달력 Month
const months = MONTHS;

// 알림장 작성
export const NotebookEdit = () => {

  const navigate = useNavigate();
  const location = useLocation();
  
  // 부모에서 전달한 context를 받아옵니다.
  const { classFilter, setClassFilter, studentFilter, setStudentFilter, dateFilter, setDateFilter }: NotebootListFilter = useOutletContext();

  const { notebookIdx } = useParams();
  const { data } = location.state;
  
  const stateData: NotebookInfo = data;

  // *************************************** useState

  const [imageLoading, setImageLoading] = useState(true);

  const [typeList, setTypeList] = useState<provinceInfo[]>(
    formattedSelectOption(NotebookType.map((type, index) => ({ label: type, value: index + 1 })))
  );
 
  // 알림장 수정 시 입력한 정보 초기값
  const defaultProps = {
    title: stateData.title,
    content: stateData.content,
    user_id: stateData.user_id,
    note_date: stateData.note_date,
    type: stateData.type,
    class_name: stateData.class_info ? stateData.class_info.name : "반 미정",
    student_name: aesCBCDecrypt(stateData.student_info.name),
    remove_file_id_list: [],
  }

  const [requestNotebookData, setRequestNotebookData] = useState<EditNotebookRequestType>(defaultProps);

  // *************************************** handle

  function changeUserQueryParams(updates: Partial<EditNotebookRequestType>) {
    setRequestNotebookData(prev => ({
      ...prev,
      ...updates,
    }));
  }

  // 카테고리 선택
  function handleTypeSelectOptions(prop: number) {
    changeUserQueryParams({ type: prop });
  }

  // 알림장 제목/내용
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    changeUserQueryParams({ [name]: value });
  }
  
  // *************************************** 파일

  // 기존에 등록된 이미지 추출
  const imageData = stateData.file_list.filter((f: ImageListType) => {
    const regex = new RegExp(patternImageFile, 'i');
    return regex.test(f.mime_type);
  });
  // 기존에 등록된 문서 추출
  const docData = stateData.file_list.filter((f: ImageListType) => {
    const regex = new RegExp(patternDocFile, 'i');
    return regex.test(f.mime_type);
  });
  
  const [prevImageData, setPrevImageData] = useState<FileListType[]>(imageData); // 이미 서버에 저장된 사진
  const [prevPreviewImg, setPrevPreviewImg] = useState<String[]>([]); // 이미 서버에 저장된 사진 파일의 url(미리보기 이미지)
  const [prevDocData, setPrevDocData] = useState<FileListType[]>(docData); // 이미 서버에 저장된 문서
  
  const [imageList, setImageList] = useState<File[]>([]); // 새로추가하는 사진 파일 자체
  const [docList, setDocList] = useState<File[]>([]); // 새로추가하는 문서 파일 자체
  
  const [previewImg, setPreviewImg] = useState<String[]>([]); // 사진 파일의 url(미리보기 이미지)
  const [previewDoc, setPreviewDoc] = useState<String[]>([]); // 문서 파일의 url(다운로드 경로)
  
  const [imageSize, setImageSize] = useState('');
  const [docSize, setDocSize] = useState('');
  const [imageCount, setImageCount] = useState(0);
  const [docCount, setDocCount] = useState(0);

  const FILEMAXCOUNT = 10;
  const FILEDOCMAXCOUNT = 5;
  const fileInput = useRef<HTMLInputElement>(null);
  const docInput = useRef<HTMLInputElement>(null);

  // 파일 선택 - input 클릭 시(사진)
  const handleButtonClick = (e: any) => {
    fileInput.current?.click();
  };

  // 파일 선택 - input 클릭 시(문서)
  const handleDocButtonClick = (e: any) => {
    if (docInput.current) docInput.current.click();
  };

  // 사진등록 handler
  const fileHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const fileArr = event.target.files;

    let _fileArr: File[] = [];

    let count = prevImageData.length + imageList.length; // 등록된 사진 수

    if (fileArr && fileArr.length) {
      
      // 기존 이미지 + 신규 이미지가 10장 초과면 새로 추가한 이미지 return
      if (count + fileArr.length > FILEMAXCOUNT) {
        alert('사진은 최대 10장만 등록 가능합니다.');
        return;
      }
      else {
        // file type 확인
        for (let j = 0; j < fileArr.length; j++) {
  
          // 이미지 확장자 포함 여부 확인
          const fileMimeType = fileArr[j].name.substring(fileArr[j].name.lastIndexOf('.'));
          const passRegex = new RegExp(patternImageFile, 'i');
          const notPassRegex = new RegExp(patternExclusionFile, 'i');
  
          const isOkExclude = passRegex.test(fileMimeType);
          const notOkExclude = notPassRegex.test(fileMimeType);
  
          if (isOkExclude && !notOkExclude) _fileArr.push(fileArr[j]);
        }
    
        count = count + _fileArr.length;
        setImageList([...imageList, ..._fileArr]);
        setImageCount(count);
  
        // 파일 url
        let fileUrls: string[] = [];
        _fileArr.forEach((file, index) => {
          const fileRead = new FileReader();
          fileRead.onload = (e) => {
            if (e.target && e.target.result) {
              fileUrls[index] = e.target.result.toString();
              setPreviewImg([...previewImg, ...fileUrls]);
            }
          };
          fileRead.onloadend = () => {
            event.target.value = "";
          };
          fileRead.readAsDataURL(file);
        });
  
        const addImageSize = getByteSize(_fileArr.map(f => f.size)) || "";
        setImageSize(String(extractNumber(imageSize) + extractNumber(addImageSize)));

      }

    }
  };

  // 사진 미리보기 전체 삭제
  function deleteAllPreviewImage() {
    setImageList([]);
    setImageSize("");
    setPreviewImg([]);

    // 기존 데이터도 DB에서 삭제
    if (prevImageData.length) {
      const removeIds = [...requestNotebookData.remove_file_id_list, ...prevImageData.map(d => d.id)];

      setPrevImageData([]);
      setPrevPreviewImg([]);
      setRequestNotebookData(prev => ({ ...prev, remove_file_id_list: removeIds }));
    }
  }

  // 사진 hover 시 파일삭제(x) 버튼 클릭 - 사진 삭제(화면상에서만)
  const handleDeleteFile = (type: string, imageIndex: number, imageId?: number) => {
    if (type === 'prev') {
      setPrevImageData(prevImageData.filter((_, index) => index !== imageIndex));
      setPrevPreviewImg(prevPreviewImg.filter((_, index) => index !== imageIndex));

      if (imageId) { // 기존 데이터만 id값이 있으므로
        const removeIds = [...requestNotebookData.remove_file_id_list, imageId];
        setRequestNotebookData(prev => ({ ...prev, remove_file_id_list: removeIds }));
      }

    }
    else {
      setImageList(imageList.filter((_, index) => index !== imageIndex));
      setPreviewImg(previewImg.filter((_, index) => index !== imageIndex));
    }
  };

  // 문서 등록
  const docHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const fileArr = event.target.files;
    let _fileArr: File[] = [];

    let count = 0; // 등록된 문서 수
    if (fileArr && fileArr.length) {
      // file type 확인
      for (let j = 0; j < fileArr.length; j++) {

        // 문서 확장자 포함 여부 확인
        const fileMimeType = fileArr[j].name.substring(fileArr[j].name.lastIndexOf('.'));
        const passRegex = new RegExp(patternDocFile, 'i');
        const notPassRegex = new RegExp(patternExclusionFile, 'i');

        const isOkExclude = passRegex.test(fileMimeType);
        const notOkExclude = notPassRegex.test(fileMimeType);

        if (isOkExclude && !notOkExclude)  _fileArr.push(fileArr[j]);


      }
      count = (prevDocData.length + _fileArr.length) > FILEDOCMAXCOUNT ? FILEDOCMAXCOUNT : _fileArr.length;

      setDocList(_fileArr.slice(0, count - prevDocData.length));
      setDocCount(count);

      // 파일 url
      _fileArr.forEach((file, index) => {
        const fileRead = new FileReader();
        fileRead.onloadend = () => {
          event.target.value = "";
        };
        fileRead.readAsDataURL(file);
      });

      setDocSize(getByteSize(_fileArr.map(f => f.size)) || '');
    }
  };

  // 문서 미리보기 전체 삭제
  function deleteAllDoc() {

    setDocList([]);
    setDocSize("");

    // 기존 데이터도 DB에서 삭제
    if (prevDocData.length) {
      const removeIds = [...requestNotebookData.remove_file_id_list, ...prevDocData.map(d => d.id)];

      setPrevDocData([]);
      setRequestNotebookData(prev => ({...prev, remove_file_id_list: removeIds}))
    }
  }

  /**
   * 문서 hover 시 파일삭제(x) 버튼 클릭 - 문서 삭제(화면상에서만)
   * @param type prev(저장된 문서), add(추가한 문서)
   * @param docIndex 
   */
  const handleDeleteDoc = (type: string, docIndex: number, docId?: number) => {
    if (type === 'prev') {
      setPrevDocData(prevDocData.filter((_, index) => index !== docIndex));

      if (docId) { // 기존 데이터만 id값이 있으므로
        const removeIds = [...requestNotebookData.remove_file_id_list, docId];
        setRequestNotebookData(prev => ({ ...prev, remove_file_id_list: removeIds }));
      }
    }
    else setDocList(docList.filter((_, index) => index !== docIndex));
  };

  // 수정
  async function putNotebookInfo() {

    try {

      if (!requestNotebookData.title) {
        alert("알림장 제목을 입력해주세요.");
        return;
      }
      if (!requestNotebookData.content) {
        alert("알림장 내용을 입력해주세요.");
        return;
      }

      // 사진/문서 합 최대 100MB 확인(104,857,600 - 오차범위 10,240(10kb))
      const maxSize = 104847360;

      if ((extractNumber(imageSize) + extractNumber(docSize)) > maxSize) {
        alert("알림장 한 번 등록 시 사진/문서의 총 용량은 최대 100MB까지만 가능합니다.");
        return;
      }

      // 새로 추가된 사진/문서가 있다면 합치기
      const fileDatas: File[] = [...imageList, ...docList];

      let goList = false;
      let formData = new FormData();

      if (fileDatas.length > 0) {
        fileDatas.forEach((file, index) => {
          formData.append("files", file);
        });
      } else formData.append("files", new Blob([]));

      const req = { ...requestNotebookData };

      const { class_name, student_name, ...reqData } = req;

      const jsonData = JSON.stringify({ ...reqData });
      const _jsonData = new Blob([jsonData], { type: "application/json" });
      formData.delete("data");
      formData.append("data", _jsonData, "data");

      const putRes = await putNotebook(Number(notebookIdx), formData);
      
      if (putRes.code === 200) {
        alert("알림장이 수정되었습니다.");
        goList = true;
      }
      else {
        alert(putRes.message);
        return;
      }

      if (goList) navigate('/notebook');

    } catch (error) {
      console.error("API error ", error);
    }
  }

  // 이미지/문서 미리보기 url 가져오기
  const subApi = useCallback(async () => {
    if (imageData.length) {
      const previewUrl = await getNotebookImageUrl(imageData);
      setPrevPreviewImg(previewUrl);
      setImageCount(imageData.length);
    }
    if (docData.length) {
      const previewUrl = await getNotebookImageUrl(docData);
      setPreviewDoc(previewUrl);
      setDocCount(docData.length);
    }

    setImageLoading(false);
  }, []);

  // 작성 및 수정 시 새로고침 시 confirm 표시
  const handleBeforeUnload = (e: any) => {
    
    e.preventDefault();
    e.returnValue = ''; // Chrome에서 경고 메시지를 표시하기 위해 필요
    return ''; // Safari에서 confirm 대화상자 표시를 위해 필요
  };

  // 새로고침 시 confirm 표시
  const handleKeyDown = (e: any) => {
    if (e.key === 'F5') {

      e.preventDefault();
      const confirmRefresh = window.confirm("새로고침 시 조회 화면으로 돌아가게 됩니다. 정말 새로고침 하시겠습니까?");

      if (confirmRefresh) {
        navigate('/notebook'); // 목록 페이지로 이동
        window.location.reload(); // 페이지를 강제로 새로고침
      }
    }
  }

  function goList() {
    navigate(`/notebook?class=${classFilter}&student=${studentFilter}&date=${dateFilter}`);
  }

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate]);


  useEffect(() => {
    setImageCount(prevImageData.length + imageList.length);
    setImageSize(getByteSize(imageList.map(f => f.size)) || '');
  }, [prevImageData, imageList]);

  useEffect(() => {
    setDocCount(prevDocData.length + docList.length);
    setDocSize(getByteSize(docList.map(f => f.size)) || '');
  }, [prevDocData, docList]);

  useEffect(() => {
    // 이미지/문서 파일의 경우 url 가져오기
    subApi();
  }, [subApi]);

  
  return (
    <>
      <PageHeaderTitleButtonStyle>
        <p className="header-title">알림장 수정</p>
        <div className="button-wrap">
          <SolidPrimaryWhiteBtn onClick={goList}>
            취소
          </SolidPrimaryWhiteBtn>
          <SolidPrimaryBtn onClick={putNotebookInfo}>
            완료
          </SolidPrimaryBtn>
        </div>
      </PageHeaderTitleButtonStyle>
      <PageArticleWrap>
        <nav className="filter-container">
          <div className="filter-wrap">
            <label>작성일</label>
            <input type="text" value={requestNotebookData.note_date} readOnly />
          </div>
          <div className="filter-wrap">
            <label>카테고리</label>
            <SelectOption
              optionData={typeList}
              defaultValue={requestNotebookData.type}
              onChange={(prop: number) => handleTypeSelectOptions(prop)}
            />
          </div>
          <SelectFilterWrap>
            <label>반</label>
            <input type="text" value={requestNotebookData.class_name} disabled />
            {/* <input type="text" value={checkedClassNum === classDataCopy.length ? "전체" : checkedClassListByName} placeholder="선택해주세요" readOnly onClick={() => setToggleClassCheckbox(prev => !prev)}/> */}
            {/* <SelectOptionWrapContainer style={{ display: toggleClassCheckbox ? "flex" : "none" }}>
              <SelectWrapC>
                <SelectInputWrapR>
                  <label htmlFor="classAll">전체({classDataCopy.length})</label>
                  <input
                    id="classAll" type="checkbox" value={0}
                    onChange={handleAllCheck}
                    checked={checkedClassNum === classDataCopy.length}
                  />
                </SelectInputWrapR>
                {classDataCopy.map(c => (
                  <SelectInputWrapR>
                    <label htmlFor={`${c.name}${c.id}`}>{ c.name }</label>
                    <input
                      id={`${c.name}${c.id}`} type="checkbox" value={c.id}
                      onChange={() => handleCheckChange(c.id, c.name)}
                      checked={checkedClassListById.includes(c.id)}
                    />
                  </SelectInputWrapR>
                ))}
              </SelectWrapC>
            </SelectOptionWrapContainer> */}
          </SelectFilterWrap>
          <SelectFilterWrap>
            <label>학생</label>
            <input type="text" value={requestNotebookData.student_name} disabled />
            {/* <input type="text" value={
              !checkedStudentNum ? "" : checkedStudentNum === studentList.length ? `전체(${checkedStudentNum})` : checkedStudentListByName}
              placeholder="반을 먼저 선택해주세요"
              disabled={!checkedClassNum}
              readOnly onClick={() => setToggleStudentCheckbox(prev => !prev)} /> */}
            {/* <SelectOptionWrapContainer style={{ display: toggleStudentCheckbox ? "flex" : "none" }}>
              {studentList.length ? 
                <SelectWrapC>
                  <>
                    <SelectInputWrapR>
                      <label htmlFor="studentAll">전체({studentList.length})</label>
                      <input
                        id="studentAll" type="checkbox" value={0}
                        onChange={handleStudentAllCheck}
                        checked={checkedStudentNum === studentList.length}
                      />
                    </SelectInputWrapR>
                    {studentList.map((s, idx) => (
                      <SelectInputWrapR>
                        <label htmlFor={`${s.name}${s.id}${idx}`}>{ aesCBCDecrypt(s.name) }</label>
                        <input
                          id={`${s.name}${s.id}${idx}`} type="checkbox" value={s.id}
                          onChange={() => handleStudentCheckChange(s.id, aesCBCDecrypt(s.name))}
                          checked={checkedStudentListById.includes(s.id)}
                        />
                      </SelectInputWrapR>
                    ))}
                  </>
                </SelectWrapC>
                : <div style={{width: '100%', textAlign: 'center'}}>선택된 학생이 없어요.</div>
              }
            </SelectOptionWrapContainer> */}
          </SelectFilterWrap>
        </nav>
        <EditContentContainer>
          <EditArticle>
            <div className="edit-article-header">
              <span className="edit-article-header-title">내용 작성</span>
              { stateData.update_date &&  <span>마지막 수정 일자: {stateData.update_date}</span> }
            </div>
            <div className="edit-article-content">
              <div>
                <input
                  type="text"
                  name="title"
                  id="title"
                  value={requestNotebookData.title}
                  onChange={handleInputChange}
                  placeholder="알림장 제목 입력"
                />
              </div>
              <div>
                <textarea
                  name="content"
                  id="content"
                  cols={30}
                  rows={10}
                  value={requestNotebookData.content}
                  onChange={handleInputChange}
                  placeholder="알림장 내용 작성"
                ></textarea>
              </div>
            </div>
          </EditArticle>
          <EditArticle>
            {imageLoading ? <Loading /> : 
              <>
                <div className="edit-article-header">
                  <p>
                    <span className="edit-article-header-title">
                      사진 등록(최대 10장)
                      <span style={{fontSize: '0.625rem', color: "e1e1e1", marginLeft: '0.25rem'}}>{imageSize ? `추가 사진 약 ${imageSize}` : ''}</span>
                    </span>
                  </p>
                  <SolidRedBtn type="button" onClick={deleteAllPreviewImage}>
                    전체 지우기
                  </SolidRedBtn>
                </div>
                <div className="file-wrap">
                  <FileOneWrap onClick={handleButtonClick}>
                    <img src="/image/icon/camera.svg" alt="camera" />
                    <label>{imageCount}/10</label>
                    <input
                      type="file"
                      name="file"
                      onChange={(e) => fileHandleChange(e)}
                      accept=".jpg, .png, .jpeg"
                      style={{ display: "none" }}
                      ref={fileInput}
                      multiple
                    />
                  </FileOneWrap>
                  {prevImageData.length !== 0 &&
                    prevImageData.map((image, index) => (
                      <FileOneWrap key={index}>
                        <img
                          src={`${prevPreviewImg[index]}`}
                          className="preview-image"
                          alt="preview"
                        />
                        <p style={{ display: "none" }}>{image.origin_file_name}</p>
                        <div
                          className="delete-preview-image"
                          onClick={() => handleDeleteFile("prev", index, image.id)}
                        >
                          <img
                            src="/image/icon/cancel.svg"
                            className="cancel-icon"
                            alt="cancel"
                          />
                        </div>
                      </FileOneWrap>
                    ))}
                  {imageList.length !== 0 &&
                    imageList.map((image, index) => (
                      <FileOneWrap key={index}>
                        <img
                          src={`${previewImg[index]}`}
                          className="preview-image"
                          alt="preview"
                        />
                        <p style={{ display: "none" }}>{image.name}</p>
                        <div
                          className="delete-preview-image"
                          onClick={() => handleDeleteFile("add", index)}
                        >
                          <img
                            src="/image/icon/cancel.svg"
                            className="cancel-icon"
                            alt="cancel"
                          />
                        </div>
                      </FileOneWrap>
                    ))}
                </div>
              </>
            }
          </EditArticle>
          {/* 앱에서는 문서 등록이 안되기 때문에 웹은 주석처리 진행 */}
          {/* <EditArticle>
            <div className="edit-article-header">
              <p>
                <span className="edit-article-header-title">
                  문서 등록({docCount})
                  <span style={{fontSize: '0.625rem', color: "e1e1e1", marginLeft: '0.25rem'}}>{docSize ? `추가 문서 약 ${docSize}` : ''}</span>
                </span>
              </p>
              <SolidRedBtn type="button" onClick={deleteAllDoc} >
                전체 지우기
              </SolidRedBtn>
            </div>
            <div className="doc-wrap">
              <DocumentWrap onClick={handleDocButtonClick}>
                <label>+ 문서 등록하기</label>
                <input
                  type="file"
                  name="file"
                  onChange={(e) => docHandleChange(e)}
                  accept=".pdf, .pptx, .docx, .xlsx, .xls"
                  style={{ display: "none" }}
                  ref={docInput}
                  multiple
                />
              </DocumentWrap>
              {prevDocData.length !== 0 && prevDocData.map((resDoc, index) => (
                <AttachFileWrap key={index}>
                  <div>
                    <DocIcon className={(resDoc.mime_type).toLocaleLowerCase()}/>
                    <EllipsisTextColumn>{resDoc.origin_file_name}</EllipsisTextColumn>
                    <div
                      className="delete-doc"
                      onClick={() => handleDeleteDoc("prev", index, resDoc.id)}
                    >
                      <img src="/image/icon/close.svg" alt="close" />
                    </div>
                  </div>
                </AttachFileWrap>
              ))}
              {docList.length !== 0 &&
                docList.map((doc, index) => (
                  <AttachFileWrap key={index}>
                    <div>
                      <DocIcon
                        className={doc.name.substring( doc.name.lastIndexOf(".") + 1 ).toLocaleLowerCase()}
                      />
                      <EllipsisTextColumn>{doc.name}</EllipsisTextColumn>
                      <div
                        className="delete-doc"
                        onClick={() => handleDeleteDoc("add", index)}
                      >
                        <img src="/image/icon/close.svg" alt="close" />
                      </div>
                    </div>
                  </AttachFileWrap>
                ))}
            </div>
          </EditArticle> */}
        </EditContentContainer>
      </PageArticleWrap>
    </>
  );
}

// 알림장 작성
export const NotebookWrite = () => {

  const navigate = useNavigate();
  
  // 부모에서 전달한 context를 받아옵니다.
  const { classFilter, setClassFilter, studentFilter, setStudentFilter, dateFilter, setDateFilter }: NotebootListFilter = useOutletContext();
  
  // 전역 데이터
  const user_role = useRecoilValue(userRoleState);

  const [classList, setClassList] = useState<ClassInfo[]>([]);
  const [classId, setClassId] = useState(-1);
  
  const { user, access } = useLoginUserInfo();
  const { user_id } = access;

  // *************************************** useState

  //완료 버튼 클릭 시 중복 클릭/등록을 막기
  const [isUpLoading, setIsUpLoading] = useState(false);

  const [studentList, setStudentList] = useState<StudentInfo[]>([]);

  const [typeList, setTypeList] = useState<provinceInfo[]>(
    formattedSelectOption(NotebookType.map((type, index) => ({ label: type, value: index + 1 })), "선택")
  );
 
  // 알림장 등록/수정 시 입력한 정보 초기값
  const today = formattedDateHyphenYYYYMMDD(new Date());
  const defaultProps = {
    title: "",
    content: "",
    user_id: user.id,
    class_id: user_role === ROLE_TEACHER ? classId : 0,
    note_date: today,
    type: 0,
    student_ids: [],
    class_name: "",
    student_names: [],
  }

  const [requestNotebookData, setRequestNotebookData] = useState<NotebookRequestType>(defaultProps);

  // 반 메뉴 toggle
  const classSelectRef = useRef<HTMLDivElement>(null);
  const [isClassSelectOpen, setIsClassSelectOpen] = useState(false);
  // 학생 메뉴 toggle
  const studentSelectRef = useRef<HTMLDivElement>(null);
  const [isStudentSelectOpen, setIsStudentSelectOpen] = useState(false);

  // 선택한 반
  const [checkedClassListById, setCheckedClassListById] = useState<number[]>([]);
  const [checkedClassListByName, setCheckedClassListByName] = useState<string[]>([""]);
  const checkedClassNum = checkedClassListById.length;
  
  // 선택한 학생
  const [checkedStudentListById, setCheckedStudentListById] = useState<number[]>([]);
  const [checkedStudentListByName, setCheckedStudentListByName] = useState<string[]>([]);
  const checkedStudentNum = checkedStudentListById.length;
  const allStudentNum = classList.flatMap((c: ClassInfo) => c.student_list).length;

  // *************************************** handle

  function changeUserQueryParams(updates: Partial<NotebookRequestType>) {
    setRequestNotebookData(prev => ({
      ...prev,
      ...updates,
    }));
  }

  // 카테고리 선택
  function handleTypeSelectOptions(prop: number) {
    changeUserQueryParams({ type: prop });
  }

  // 반 선택 체크/해제 handle
  const handleCheckChange = (id: number, name: string) => {

    const isChecked = checkedClassListById.includes(id);

    const studentList = classList.find((c: ClassInfo) => c.id === id)?.student_list;

    if (isChecked) {
      setCheckedClassListById((prev) => prev.filter((el) => el !== id));
      setCheckedClassListByName((prev) => prev.filter((el) => el !== name));

      if (studentList && studentList.length) {
        setStudentList((prev) => prev.filter((el) => !studentList.some((s: StudentInfo) => el.id === s.id)));
        setCheckedStudentListById((prev) => prev.filter((el) => !studentList.some((s: StudentInfo) => el === s.id)));
        setCheckedStudentListByName((prev) => prev.filter((el) => !studentList.some((s: StudentInfo) => el === aesCBCDecrypt(s.name))));
      }

    } else {
      setCheckedClassListById((prev) => [...prev, id]);
      setCheckedClassListByName((prev) => [...prev, name]);

      if (studentList && studentList.length) {
        setStudentList((prev) => [...prev, ...studentList]);
      }
    }

  };

  // 학생 선택 체크/해제 handle
  const handleStudentCheckChange = (id: number, name: string) => {
    
    const isChecked = checkedStudentListById.includes(id);

    if (isChecked) {
      setCheckedStudentListById((prev) => prev.filter((el) => el !== id));
      setCheckedStudentListByName((prev) => prev.filter((el) => el !== name));
    } else {
      setCheckedStudentListById((prev) => [...prev, id]);
      setCheckedStudentListByName((prev) => [...prev, name]);
    }
  };
  
  // 반 전체 선택
  const handleAllCheck = ({ target: { checked } }: { target: { checked: boolean }; }) => {

    const allStudentList = classList.flatMap((c: ClassInfo) => c.student_list);
    
    if (checked) {
      setCheckedClassListById(classList.map((c: ClassInfo) => c.id));
      setCheckedClassListByName(classList.map((c: ClassInfo) => c.name));
      setStudentList(allStudentList);
    } else {
      setCheckedClassListById([]);
      setCheckedClassListByName([]);
      setStudentList([]);
      setCheckedStudentListById([]);
      setCheckedStudentListByName([]);
    }
  };
  
  // 학생 전체 선택
  const handleStudentAllCheck = ({ target: { checked } }: { target: { checked: boolean }; }) => {

    if (checked) {
      setCheckedStudentListById(studentList.map(s => s.id));
      setCheckedStudentListByName(studentList.map(s => aesCBCDecrypt(s.name)));
    } else {
      setCheckedStudentListById([]);
      setCheckedStudentListByName([]);
    }
  };

  // 알림장 제목/내용
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    changeUserQueryParams({ [name]: value });
  }
  
  function goList() {
    if (!classFilter && !studentFilter && !dateFilter) {
      navigate('/notebook');
    }
    else {
      navigate(`/notebook?class=${classFilter}&student=${studentFilter}&date=${dateFilter}`);
    }
  }
  
  // *************************************** 파일

  const [docList, setDocList] = useState<File[]>([]); // 문서 파일 자체
  const [imageList, setImageList] = useState<File[]>([]); // 사진 파일 자체
  const [previewImg, setPreviewImg] = useState<String[]>([]); // 사진 파일의 url(미리보기 이미지)
  
  const [imageSize, setImageSize] = useState('');
  const [docSize, setDocSize] = useState('');
  const [imageCount, setImageCount] = useState(0);
  const [docCount, setDocCount] = useState(0);

  const FILEMAXCOUNT = 10;
  const FILEDOCMAXCOUNT = 5;
  const fileInput = useRef<HTMLInputElement>(null);
  const docInput = useRef<HTMLInputElement>(null);

  // 파일 선택 - input 클릭 시(사진)
  const handleButtonClick = (e: any) => {
    fileInput.current?.click();
  };

  // 파일 선택 - input 클릭 시(문서)
  const handleDocButtonClick = (e: any) => {
    if (docInput.current) docInput.current.click();
  };

  // 사진 등록 handler
  const fileHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const fileArr = event.target.files;
    
    let _fileArr: File[] = [];

    let count = imageList.length; // 등록된 사진 수
    
    if (fileArr && fileArr.length) {

      // 기존 이미지 + 신규 이미지가 10장 초과면 새로 추가한 이미지 return
      if (count + fileArr.length > FILEMAXCOUNT) {
        alert('사진은 최대 10장만 등록 가능합니다.');
        return;
      }
      else {
        // file type 확인
        for (let j = 0; j < fileArr.length; j++) {
  
          const fileMimeType = fileArr[j].name.substring(fileArr[j].name.lastIndexOf('.'));
          const notPassRegex = new RegExp(patternExclusionFile, 'i');
          const notOkExclude = notPassRegex.test(fileMimeType);
  
  
          if (fileArr[j].type.includes("image") && !notOkExclude) _fileArr.push(fileArr[j]);
        }

        count = count + _fileArr.length;
        setImageList([...imageList, ..._fileArr]);
        setImageCount(count);

        // 파일 url
        let fileUrls: string[] = [];
        _fileArr.forEach((file, index) => {
          const fileRead = new FileReader();
          fileRead.onload = (e) => {
            if (e.target && e.target.result) {
              fileUrls[index] = e.target.result.toString();
              setPreviewImg([...previewImg, ...fileUrls]);
            }
          };
          fileRead.onloadend = () => {
            event.target.value = "";
          };
          fileRead.readAsDataURL(file);
        });

        const addImageSize = getByteSize(_fileArr.map(f => f.size)) || "";
        setImageSize(String(extractNumber(imageSize) + extractNumber(addImageSize)));

      }

    }
  };

  // 사진 미리보기 전체 삭제
  function deleteAllPreviewImage() {
    setImageList([]);
    setPreviewImg([]);
    setImageSize("");
  }

  // 사진 hover 시 파일삭제(x) 버튼 클릭 - 사진 삭제(화면상에서만)
  const handleDeleteFile = (imageIndex: number) => {
    setImageList(imageList.filter((img, index) => index !== imageIndex));
    setPreviewImg(previewImg.filter((img, index) => index !== imageIndex));
  };

  // 문서 등록
  const docHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const allowedExtensions = ["pdf", "pptx", "docx", "xlsx"];
    const fileArr = event.target.files;
    let _fileArr: File[] = [];

    let count = 0; // 등록된 문서 수
    if (fileArr && fileArr.length) {
      // file type 확인
      for (let j = 0; j < fileArr.length; j++) {
        const fileName = fileArr[j].name;
        const fileExtension = fileName
          .substring(fileName.lastIndexOf(".") + 1)
          .toLowerCase(); // 파일 이름으로부터 확장자 추출

        if (fileExtension && allowedExtensions.includes(fileExtension))
          _fileArr.push(fileArr[j]);
      }
      count = _fileArr.length > FILEDOCMAXCOUNT ? FILEDOCMAXCOUNT : _fileArr.length;
      setDocList(_fileArr.slice(0, count));
      setDocCount(count);

      // 파일 url
      _fileArr.forEach((file, index) => {
        const fileRead = new FileReader();
        fileRead.onloadend = () => {
          event.target.value = "";
        };
        fileRead.readAsDataURL(file);
      });

      setDocSize(getByteSize(_fileArr.map(f => f.size)) || '');
    }
  };

  // 문서 미리보기 전체 삭제
  function deleteAllDoc() {
    setDocList([]);
    setDocSize("");
  }

  // 문서 hover 시 파일삭제(x) 버튼 클릭 - 문서 삭제(화면상에서만)
  const handleDeleteDoc = (docIndex: number) => {
    setDocList(docList.filter((doc, index) => index !== docIndex));
  };

  // 등록
  async function createNotebookInfo() {

    try {

      // 반 선택 확인
      if (checkedClassNum === 0 || (checkedClassNum && checkedStudentNum === 0)) {
        alert("반과 학생을 선택해주세요.");
        return;
      }

      // 타입 확인
      if (!requestNotebookData.type) {
        alert("알림장 카테고리를 선택해주세요.");
        return;
      }

      if (!requestNotebookData.title) {
        alert("알림장 제목을 입력해주세요.");
        return;
      }
      if (!requestNotebookData.content) {
        alert("알림장 내용을 입력해주세요.");
        return;
      }

      // 사진/문서 합 최대 100MB 확인(104,857,600 - 오차범위 10,240(10kb))
      const maxSize = 104847360;

      if ((extractNumber(imageSize) + extractNumber(docSize)) > maxSize) {
        alert("알림장 한 번 등록 시 사진/문서의 총 용량은 최대 100MB까지만 가능합니다.");
        return;
      }
      
      setIsUpLoading(true);

      // 이미지/문서 하나로 합치기
      const fileDatas: File[] = [...imageList, ...docList];

      let goList = false;
      let formData = new FormData();

      if (fileDatas.length > 0) {
        fileDatas.forEach((file, index) => {
          formData.append("files", file);
        });
      } else formData.append("files", new Blob([]));
      

      const req = { ...requestNotebookData };

      const promiseRes = [];
      const promises: any[] = [];

      // 반/학생 전체 선택인 경우
      if (classList.length === checkedClassNum && checkedStudentNum === allStudentNum) {
        checkedClassListById.map(id => {

          const { class_name, student_names, ...reqData } = req;
          reqData.class_id = id;
          reqData.student_ids = [];

          const jsonData = JSON.stringify({ ...reqData });
          const _jsonData = new Blob([jsonData], { type: "application/json" });
          formData.delete("data");
          formData.append("data", _jsonData, "data");
          
          promises.push(postNotebook(formData));

        });
      }
      else {
        // return;
        checkedClassListById.forEach(checkId => {

          // 관리자가 등록하는 경우
          if (user_role === ROLE_DIRECTOR) {
            
            const findClass = classList.find((c: ClassInfo) => c.id === checkId);
            const { class_name, student_names, ...reqData } = req;
            
            // 반이 있고, 반에 학생이 있는 경우
            if (findClass && findClass.student_list.length) {
              const findStudent = findClass.student_list.filter((s: StudentInfo) => checkedStudentListById.some(sId => s.id === sId));

              if (findStudent.length === 0) return;
  
              reqData.class_id = checkId;
              // findStudent에 학생이 있으면서 findClass의 student_list의 길이와 같은 경우(한 반의 전체일 때때)
              if (findStudent.length !== 0 && findStudent.length === findClass.student_list.length) {
                reqData.student_ids = [];
              }
              else {
                reqData.student_ids = findStudent.map((s: StudentInfo) => s.id);
              }
              
              const jsonData = JSON.stringify({ ...reqData });
              const _jsonData = new Blob([jsonData], { type: "application/json" });
              formData.delete("data");
              formData.append("data", _jsonData, "data");
  
              promises.push(postNotebook(formData));
            }
            
          }
          // 선생님이 등록하는 경우
          else {
            const findClass = classList[0];
            const { class_name, student_names, ...reqData } = req;

            if (findClass && findClass.student_list.length) {
              const findStudent = findClass.student_list.filter((s: StudentInfo) => checkedStudentListById.some(sId => s.id === sId));

              reqData.class_id = checkId;
              // 선택한 여러반 중 한 반의 학생을 전체 선택한 경우
              if (findStudent.length === findClass.student_list.length) {
                reqData.student_ids = []; // class_id만 보내야해서
              }
              else {
                reqData.student_ids = findStudent.map((s: StudentInfo) => s.id);
              }
  
              const jsonData = JSON.stringify({ ...reqData });
              const _jsonData = new Blob([jsonData], { type: "application/json" });
              formData.delete("data");
              formData.append("data", _jsonData, "data");
  
              promises.push(postNotebook(formData));
            }

          }

        })
      }
      
      const results = await Promise.allSettled(promises);

      promiseRes.push(...results);

      const successCnt = promiseRes.filter(res => res.status === 'fulfilled' && res.value.code === 200).length;
      const erroRes = promiseRes.filter(res => res.status === 'rejected' || (res.status === 'fulfilled' && res.value.code !== 200));
      if (checkedClassListById.length === successCnt) {
        if (checkedClassListById.length === 1 && checkedStudentNum === 1) {
          alert('알림장이 등록됐습니다.');
        }
        else {
          alert('알림장 전체가 등록됐습니다..');
        }
        goList = true;
      }
      else if (checkedClassListById.length !== 0 && successCnt === 0) {
        alert('알림장 전체 등록 실패했습니다..');
        console.error(`Error in Promise `, erroRes);
        goList = true;
      }
      else {
        alert('알림장 일부만 등록됐습니다.');
        console.error(`부분 Error in Promise `, erroRes);
        goList = true;
      }

      // 전체 반, 전체 학생, 오늘 날짜로 이동
      setClassFilter("");
      setStudentFilter("");
      setDateFilter(today);

      if (goList) navigate('/notebook');
      

    } catch (error) {
      console.error("API error ", error);
    }
    finally {
      setIsUpLoading(false);
    }
  }

  /**
   * 담당 class 가져오기
   */
  const getClassList = useCallback(async () => {

    try {

      // 담당반 클래스 아이디 리스트 업데이트
      const classQueryParams: ClassQueryParams = {
        name: "",
        user_id: user_role === ROLE_DIRECTOR ? 0 : user_id,
        response_format: "",
        page: 1,
        size: 99999999
      };
  
      const classResult: ListResult<ClassInfo> = await getClass(classQueryParams);
  
      // 반 정보가 없는 경우
      if (classResult.code !== 200 || (classResult.code === 200 && classResult.data.length === 0)) {
        setClassList([]);
      }
      else {
        const userClassList: ClassInfo[] = classResult.data;
        setClassList(userClassList);
  
        const _classId = user_role === ROLE_DIRECTOR ? 0 : userClassList.length ? userClassList[0].id : -1;
        setClassId(_classId);

        // 보여주는 class_name, 작성 시 전달하는 class_id 설정
        setRequestNotebookData(prev => ({ ...prev, class_id: _classId }));
        setCheckedClassListById(user_role === ROLE_DIRECTOR ? [] : [_classId]);
        setCheckedClassListByName(user_role === ROLE_DIRECTOR ? [] : [userClassList[0].name]);
      }
      
    } catch (error) {
      console.error("api error ", error);
    }
   

  }, [user_role, user_id]);

  // ****************************** 새로고침 관련

  // 작성 및 수정 시 새로고침 시 confirm 표시
  const handleBeforeUnload = (e: any) => {
    
    e.preventDefault();
    e.returnValue = ''; // Chrome에서 경고 메시지를 표시하기 위해 필요
    return ''; // Safari에서 confirm 대화상자 표시를 위해 필요
  };

  // 새로고침 시 confirm 표시
  const handleKeyDown = (e: any) => {
    if (e.key === 'F5') {

      e.preventDefault();
      const confirmRefresh = window.confirm("새로고침 시 조회 화면으로 돌아가게 됩니다. 정말 새로고침 하시겠습니까?");

      if (confirmRefresh) {
        navigate('/notebook'); // 목록 페이지로 이동
        window.location.reload(); // 페이지를 강제로 새로고침
      }
    }
  }

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate]);

  // ****************************** mouse 이벤트 관련

  // 다른 영역 클릭 시 select 숨기기
  const handleOutsideClick = (event: MouseEvent) => {
    // 반 select가 보여질 때 반 select 영역 또는 학생 select 영역이 아닌 경우 닫기
    if (classSelectRef.current &&
      (!classSelectRef.current.contains(event.target as Node)
        && (studentSelectRef.current && !studentSelectRef.current.contains(event.target as Node)))) {
          setIsClassSelectOpen(false);
        }
    // 학생 select가 보여질 때 반 select 영역 또는 학생 select 영역이 아닌 경우 닫기
    if (studentSelectRef.current &&
      (!studentSelectRef.current.contains(event.target as Node)
        && (classSelectRef.current && !classSelectRef.current.contains(event.target as Node)))) {
          setIsStudentSelectOpen(false);
        }
  }

  // *********************** useEffect

  useEffect(() => {
    setImageCount(imageList.length);
    setImageSize(getByteSize(imageList.map(f => f.size)) || '');
  }, [imageList]);

  useEffect(() => {
    setDocCount(docList.length);
    setDocSize(getByteSize(docList.map(f => f.size)) || '');
  }, [docList]);

  useEffect(() => {
    if (user_role === ROLE_TEACHER) setStudentList(classList.flatMap((c: ClassInfo) => c.student_list));
  }, [user_role, classList]);

  useEffect(() => {
    document.addEventListener('mouseup', handleOutsideClick);
    return () => document.removeEventListener('mouseup', handleOutsideClick);
  }, []);

  // 반 정보 가져오기
  useEffect(() => {
    getClassList();
  }, [getClassList]);

  return (
    <>
      <PageHeaderTitleButtonStyle>
        <p className="header-title">알림장 신규 작성</p>
        <div className="button-wrap">
          <SolidPrimaryWhiteBtn onClick={goList} disabled={isUpLoading}>
            취소
          </SolidPrimaryWhiteBtn>
          <SolidPrimaryBtn onClick={createNotebookInfo} disabled={isUpLoading}>
            완료
          </SolidPrimaryBtn>
        </div>
      </PageHeaderTitleButtonStyle>
      <PageArticleWrap>
        <nav className="filter-container">
          <div className="filter-wrap">
            <label>작성일</label>
            <input type="text" value={today} readOnly />
          </div>
          <div className="filter-wrap">
            <label>카테고리</label>
            <SelectOption
              optionData={typeList}
              defaultValue={requestNotebookData.type}
              onChange={(prop: number) => handleTypeSelectOptions(prop)}
            />
          </div>
          <SelectFilterWrap ref={classSelectRef}>
            <label>반</label>
            {user_role === ROLE_DIRECTOR ? 
              <>
                <input
                  type="text"
                  value={checkedClassNum === classList.length ? "전체" : checkedClassListByName}
                  placeholder="선택해주세요"
                  onClick={() => setIsClassSelectOpen(true)}
                  readOnly
                />
                <SelectOptionWrapContainer style={{ display: isClassSelectOpen ? "flex" : "none" }}>
                  <SelectWrapC>
                    <SelectInputWrapR>
                      <label htmlFor="classAll">전체({classList.length})</label>
                      <CustomCheckbox
                        id="classAll" type="checkbox" value={0}
                        onChange={handleAllCheck}
                        checked={checkedClassNum === classList.length}
                      />
                    </SelectInputWrapR>
                    {classList.map((c: ClassInfo) => (
                      <SelectInputWrapR>
                        <label htmlFor={`${c.name}${c.id}`}>{ c.name }</label>
                        <CustomCheckbox
                          id={`${c.name}${c.id}`} type="checkbox" value={c.id}
                          onChange={() => handleCheckChange(c.id, c.name)}
                          checked={checkedClassListById.includes(c.id)}
                        />
                      </SelectInputWrapR>
                    ))}
                  </SelectWrapC>
                </SelectOptionWrapContainer>
              </>
              :
              <input type="text" value={checkedClassListByName} disabled />
            }
          </SelectFilterWrap>
          <SelectFilterWrap ref={studentSelectRef}>
            <label>학생</label>
            <input
              type="text"
              value={
                !checkedStudentNum ? "" : checkedStudentNum === studentList.length ? `전체(${checkedStudentNum})` : checkedStudentListByName}
              placeholder={
                `${checkedClassListById.length && !studentList.length ? "등록된 학생이 없어요." 
                  : user_role === ROLE_DIRECTOR && !studentList.length ? "반을 먼저 선택해주세요" : "학생을 선택해주세요"}`}
              disabled={!checkedClassNum}
              readOnly
              onClick={() => setIsStudentSelectOpen(true)} />
            <SelectOptionWrapContainer style={{ display: isStudentSelectOpen ? "flex" : "none" }}>
              {studentList.length ? 
                <SelectWrapC>
                  <>
                    <SelectInputWrapR>
                      <label htmlFor="studentAll">전체({studentList.length})</label>
                      <CustomCheckbox
                        id="studentAll" type="checkbox" value={0}
                        onChange={handleStudentAllCheck}
                        checked={checkedStudentNum === studentList.length}
                      />
                    </SelectInputWrapR>
                    {studentList.map((s, idx) => (
                      <SelectInputWrapR>
                        <label htmlFor={`${s.name}${s.id}${idx}`}>{ aesCBCDecrypt(s.name) }</label>
                        <CustomCheckbox
                          id={`${s.name}${s.id}${idx}`} type="checkbox" value={s.id}
                          onChange={() => handleStudentCheckChange(s.id, aesCBCDecrypt(s.name))}
                          checked={checkedStudentListById.includes(s.id)}
                        />
                      </SelectInputWrapR>
                    ))}
                  </>
                </SelectWrapC>
                : <div style={{width: '100%', textAlign: 'center'}}>선택된 학생이 없어요.</div>
              }
            </SelectOptionWrapContainer>
          </SelectFilterWrap>
        </nav>
        <EditContentContainer>
          <EditArticle>
            <div className="edit-article-header">
              <p>
                <span className="edit-article-header-title">내용 작성</span>
              </p>
            </div>
            <div className="edit-article-content">
              <div>
                <input
                  type="text"
                  name="title"
                  id="title"
                  value={requestNotebookData.title}
                  onChange={handleInputChange}
                  placeholder="알림장 제목 입력"
                />
              </div>
              <div>
                <textarea
                  name="content"
                  id="content"
                  cols={30}
                  rows={10}
                  value={requestNotebookData.content}
                  onChange={handleInputChange}
                  placeholder="알림장 내용 작성"
                ></textarea>
              </div>
            </div>
          </EditArticle>
          <EditArticle>
            <div className="edit-article-header">
              <p>
                <span className="edit-article-header-title">
                  사진 등록(최대 10장)
                  <span style={{fontSize: '0.625rem', color: "e1e1e1", marginLeft: '0.25rem'}}>{imageSize ? `약 ${imageSize}` : ''}</span>
                </span>
              </p>
              <SolidRedBtn
                type="button"
                onClick={deleteAllPreviewImage}
              >
                전체 지우기
              </SolidRedBtn>
            </div>
            <div className="file-wrap">
              <FileOneWrap onClick={handleButtonClick}>
                <img src="/image/icon/camera.svg" alt="camera" />
                <label>{imageCount}/10</label>
                <input
                  type="file"
                  name="file"
                  onChange={(e) => fileHandleChange(e)}
                  accept=".jpg, .png, .jpeg"
                  style={{ display: "none" }}
                  ref={fileInput}
                  multiple
                />
              </FileOneWrap>
              {imageList.length !== 0 &&
                imageList.map((image, index) => (
                  <FileOneWrap key={index}>
                    <img src={`${previewImg[index]}`} className="preview-image" alt="preview" />
                    <p style={{ display: "none" }}>{image.name}</p>
                    <div className="delete-preview-image" onClick={() => handleDeleteFile(index)}>
                      <img src="/image/icon/cancel.svg" className="cancel-icon" alt="cancel" />
                    </div>
                  </FileOneWrap>
                ))}
            </div>
          </EditArticle>
          {/* 앱에서는 문서 등록이 안되기 때문에 웹은 주석처리 진행 */}
          {/* <EditArticle>
            <div className="edit-article-header">
              <p>
                <span className="edit-article-header-title">
                  문서 등록({docCount})
                  <span style={{fontSize: '0.625rem', color: "e1e1e1", marginLeft: '0.25rem'}}>{docSize ? `약 ${docSize}` : ''}</span>
                </span>
              </p>
              <SolidRedBtn
                type="button"
                onClick={deleteAllDoc}
              >
                전체 지우기
              </SolidRedBtn>
            </div>
            <div className="doc-wrap">
              <DocumentWrap onClick={handleDocButtonClick}>
                <label>+ 문서 등록하기</label>
                <input
                  type="file"
                  name="file"
                  onChange={(e) => docHandleChange(e)}
                  accept=".pdf, .pptx, .docx, .xlsx"
                  style={{ display: "none" }}
                  ref={docInput}
                  multiple
                />
              </DocumentWrap>
              {docList.length !== 0 &&
                docList.map((doc, index) => (
                  <AttachFileWrap key={index}>
                    <div>
                      <DocIcon
                        className={(doc.name.substring( doc.name.lastIndexOf(".") + 1 ).toLocaleLowerCase())}
                      />
                      <EllipsisTextColumn>{doc.name}</EllipsisTextColumn>
                      <div
                        className="delete-doc"
                        onClick={() => handleDeleteDoc(index)}
                      >
                        <img src="/image/icon/close.svg" alt="close" />
                      </div>
                    </div>
                  </AttachFileWrap>
                ))}
            </div>
          </EditArticle> */}
        </EditContentContainer>
      </PageArticleWrap>
    </>
  );
}

/**
 * 알림장 상단 필터 유지(반/학생/날짜)
 * - 페이지 이동 후에도 이전에 선택한 필터 유지용
 */
type NotebootListFilter = {
  classFilter: string;
  setClassFilter: (filter: string) => void;
  studentFilter: string;
  setStudentFilter: (filter: string) => void;
  dateFilter: string;
  setDateFilter: (filter: string) => void;
}

export const NotebookList = () => {

  const URL = url;
  const navigate = useNavigate();
  
  // 부모에서 전달한 context를 받아옵니다.
  const { classFilter, setClassFilter, studentFilter, setStudentFilter, dateFilter, setDateFilter }: NotebootListFilter = useOutletContext();

  // 전역 데이터
  const user_role = useRecoilValue(userRoleState);
  const selectSiteId = useRecoilValue(selectSiteIdState);

  const { access } = useLoginUserInfo();
  const { user_id } = access;

  const holidayList = useRecoilValue(holidayState);

  // *************************************** useState
  const [loading, setLoading] = useState(true);
  
  const [classList, setClassList] = useState<ClassInfo[]>([]);
  const [classId, setClassId] = useState(-1);
  const [classSelectOption, setClassSelectOption] = useState<provinceInfo[]>([]);

  // 알림장 List 관련
  const [notebookList, setNotebookList] = useState<NotebookInfo[]>([]); // 전체 알림장
  const [toTeacherNotebookList, setToTeacherNotebookList] = useState<NotebookInfo[]>([]); // 학부모 -> 선생님
  const [totalCountToTeacher, setTotalCountToTeacher] = useState(0);
  const [toParentNotebookList, setToParentNotebookList] = useState<NotebookInfo[]>([]); // 선생님 -> 학부모
  const [totalCountToParent, setTotalCountToParent] = useState(0);

  // 필터용
  const [studentSelectOption, setStudentSelectOption] = useState<provinceInfo[]>([]);
  const [startDate, setStartDate] = useState<Date>(dateFilter ? new Date(dateFilter) : new Date());

  // 알림장 시작일/종료일/반/학생/작성자권한
  const today = formattedDateYYYYMMDD(new Date());
  
  const defaultProps = {
    page: 1,
    size: 100,
    create_user_type: 0, // 1 선생님 2 학부모
    class_id: classFilter ? Number(classFilter) : classId ? classId : 0,
    student_id: Number(studentFilter) || 0,
    note_start_date: dateFilter || today,
    note_end_date: dateFilter || today,
  }
  const [notebookQueryParams, setNotebookQueryParams] = useState<NotebookQueryParams>(defaultProps);

  // 목록 선택 - 선생님/학부모
  // const [activeMenu, setActiveMenu] = useState("toParent");

  // 상세보기 시 알림장 하나에 대한 정보 초기값
  const [detailNotebookOne, setDetailNotebookOne] = useState<DetaileNotebookProps>({
    id: 0,
    type: 0,
    title: "",
    content: "",
    is_group: 0,
    user_id: 0,
    user_name: "",
    create_user_class_name: "",
    create_user_type: 0,
    like_count: 0,
    note_date: "",
    reg_date: "",
    update_date: "",
    file_list: [],
    student_name: "",
    class_name: "",
  });

  // *************************************** handle
  
  function handleCreateNotebook() {
    navigate(`write`, { state: { type: 'create', data: [] } });
  }

  // 사용자 검색 조건 변경
  function changeUserQueryParams(updates: Partial<NotebookQueryParams>) {
    setNotebookQueryParams(prev => ({
      ...prev,
      ...updates,
    }));
  }

  // 반 선택
  function handleClassSelectOptions(prop: number) {
    changeUserQueryParams({ class_id: prop });

    if (prop === 0) {
      setStudentSelectOption([]);
    }
    else {
      const studentList = classList.find((c: ClassInfo) => c.id === prop)?.student_list;
      if (studentList?.length) {
        setStudentSelectOption(formattedSelectOption(studentList.map((s: StudentInfo) => ({label: aesCBCDecrypt(s.name), value: s.id})), "모두보기"));
      }
      else setStudentSelectOption([]);
    }

    changeUserQueryParams({ student_id: 0 });

    setClassFilter(`${prop}`);
  }

  // 학생 선택
  function handleStudentSelectOptions(prop: number) {
    changeUserQueryParams({ student_id: prop });

    setStudentFilter(`${prop}`);
  }

  // 날짜 선택
  function handleSearchStartDate(date: Date) {
    setStartDate(date || new Date());
    changeUserQueryParams({ note_start_date: formattedDateYYYYMMDD(date), note_end_date: formattedDateYYYYMMDD(date) });

    setDateFilter(formattedDateHyphenYYYYMMDD(date));
  }

  // 작성자 탭 변경
  // const handleJoinType = (type: string) => {
  //   setActiveMenu(type);
  //   changeUserQueryParams({create_user_type: type === "toTeacher" ? 2 : 1})
  // };

  /**
   * 알림장 수정하기
   * @param notebookIdx 
   * @param notebookOne 
   */
  function handlePutNotebook(notebookIdx: number, notebookOne: NotebookInfo | undefined) {
    // 목록에서 필터값이 있다면 필터값을 쿼리 파라미터로 전달
    if (!classFilter && !studentFilter && !dateFilter) {
      navigate(`${notebookIdx}`, { state: { type: 'edit', data: notebookOne } });
    }
    else 
      navigate(`${notebookIdx}?&class=${classFilter}&student=${studentFilter}&date=${dateFilter}`, { state: { type: 'edit', data: notebookOne } });
  }

  // 필터 초기화
  function resetFilter() {
    // 검색 필터 초기화
    setStartDate(new Date());
    changeUserQueryParams({ class_id: classId, student_id: 0, note_start_date: today, note_end_date: today });
    setStudentSelectOption([]);
    // 필터 저장 초기화
    setClassFilter("");
    setStudentFilter("");
    setDateFilter(formattedDateHyphenYYYYMMDD(new Date()));
  }

  // *************************************** 알림장 상세보기 - 모달

  // 상세보기 클릭 시 해당 알림장의 id
  const [notebookClickId, setNotebookClickId] = useState<number>(0);

  // 이미지가 있는 경우 < > 넘길 때 index
  const [modalImageUrlList, setModalImageUrlList] = useState<FileListType[]>([]);
  const [modalDocUrlList, setModalDocUrlList] = useState<FileListType[]>([]);

  const [imageNum, setImageNum] = useState(1);

  // 줌 관련
  const [showZoom, setShowZoom] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0, dx: 0, dy: 0 });
  const imageRef = useRef<HTMLDivElement>(null);

  function increaseNum() {
    if (imageNum !== modalImageUrlList.length) setImageNum((prev) => prev + 1);
  }

  function decreaseNum() {
    if (imageNum !== 1) setImageNum((prev) => prev - 1);
  }

  //모달 상태
  const [modalProps, setModalProps] = useState<ModalPropsInterface>({
    isOpen: false,
    isClose: () => {},
    title: "",
    content: null,
    button: null,
    type: ""
  });
  
  //반 등록/수정 모달 열기 버튼 클릭 시
  const openModal = (modalType:ModalType) => {
    let title: ModalTitle = "";
    let content:JSX.Element = <></>;
    let button:JSX.Element = <></>;
    switch (modalType) {
      case "showNotebook":
          title = "알림장 상세내용";
          break;
    }

    setModalProps({
      isOpen: true,
      isClose: () => setModalProps({...modalProps, isOpen: false}),
      title: title,
      content: content,
      button: button,
      type: modalType
    });
  }

  const changeRequestNotebookHandler = (noteIdx: number, notebookInfo: NotebookInfo) => {
    setModalImageUrlList([]);
    setModalDocUrlList([]);
    setNotebookClickId(noteIdx);
    setImageNum(1);
    setDetailNotebookOne({
      id: notebookInfo.id,
      type: notebookInfo.type,
      title: notebookInfo.title,
      content: notebookInfo.content,
      is_group: notebookInfo.is_group,
      user_id: notebookInfo.user_id,
      user_name: notebookInfo.user_name,
      create_user_class_name: notebookInfo.create_user_class_name,
      create_user_type: notebookInfo.create_user_type,
      like_count: notebookInfo.like_count,
      note_date: notebookInfo.note_date,
      reg_date: notebookInfo.reg_date,
      update_date: notebookInfo.update_date || "",
      file_list: notebookInfo.file_list,
      student_name: aesCBCDecrypt(notebookInfo.student_info.name),
      class_name: notebookInfo.class_info ? notebookInfo.class_info.name : "반 미정",
    });

    if (notebookInfo.file_list.length) {

      const { file_list } = notebookInfo;
      
      const imageDatas = file_list.filter((file: FileListType) => {
        let imageData = {};
        const regex = new RegExp(patternImageFile, 'i');
        const exclude = regex.test(file.mime_type);

        if (exclude) {
          imageData = {
            file_name: file.file_name,
            file_path: file.file_path,
            mime_type: file.mime_type,
            origin_file_name: file.origin_file_name,
            notebook_id: file.notebook_id,
            file_size: file.file_size,
            id: file.id,
            reg_date: file.reg_date
          }
        }
        return imageData;
      });

      setModalImageUrlList(imageDatas);

      const docDatas = file_list.filter((file: FileListType) => {

        let docData = {};
        const regex = new RegExp(patternDocFile, 'i');
        const exclude = regex.test(file.mime_type);

        if (exclude) {
          docData = {
            file_name: file.file_name,
            file_path: file.file_path,
            mime_type: file.mime_type,
            origin_file_name: file.origin_file_name,
            notebook_id: file.notebook_id,
            file_size: file.file_size,
            id: file.id,
            reg_date: file.reg_date
          }
        }
        return docData;
      });

      setModalDocUrlList(docDatas);
    };
  }

  const WINDOWWIDTH = 1200;
  // 화면 크기 체크 함수 추가
  const checkScreenSize = () => {
    return window.innerWidth > WINDOWWIDTH;
  };

  // 마우스 Enter 이벤트 - 화면 크기 체크
  // screen크기가 너무 작으면 zoom 안되도록 설정
  const handleZoomEnter = () => {
    if (checkScreenSize()) {
      setShowZoom(true);
    }
  };

  // 마우스 이벤트
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!imageRef.current) return;

    const rect = imageRef.current.getBoundingClientRect();
    const targetElement = e.target as HTMLElement;
    const image = targetElement.tagName === 'IMG' 
      ? targetElement as HTMLImageElement : targetElement.querySelector('img');
    
    if (!image) return;

    const imageRect = image.getBoundingClientRect();

    // 이미지와 컨테이너의 여백 계산
    const offsetX = (rect.width - imageRect.width) / 2;
    const offsetY = (rect.height - imageRect.height) / 2;

    // 마우스 위치를 .image-wrap 기준으로 계산
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const frameWidth = 100;
    const frameHeight = 100;
    
    // .image-wrap 영역 내에서만 움직이도록 계산
    const boundedX = Math.max(0, Math.min(x - frameWidth / 2, rect.width - frameWidth));
    const boundedY = Math.max(0, Math.min(y - frameHeight / 2, rect.height - frameHeight));

    setZoomPosition({ x: boundedX, y: boundedY, dx: offsetX, dy: offsetY });
  };
  
  /**
   * 알림장 상세보기 모달
   * @returns 
   */
  const NotebookModalContent = (): JSX.Element => {
    const imageMaxNum = modalImageUrlList.length;
    const docMaxNum = modalDocUrlList.length;

    const URL = url;

    /**
     * 다운로드 아이콘 클릭 시 파일 다운로드
     * @param index 
     */
    // const downloadDoc = async (docNum: number) => {
    //   // const { file_name, origin_file_name } = docUrlListRef.current[docNum - 1];
    //   const { file_name, origin_file_name } = modalDocUrlList[docNum - 1];
    //   const result = await getFileOrigin(file_name); // blob
    //   const url = window.URL.createObjectURL(result);
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.setAttribute("download", origin_file_name);
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // };

    // 다운로드 클릭 시 이미지 다운로드
    const downloadImage = async (imageNum: number) => {

      let fileName = modalImageUrlList[imageNum - 1].file_name;
      const result = await getFileOrigin(fileName); // blob
      const url = window.URL.createObjectURL(result);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'test');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    }
    
    const downloadAllImage = async () => {
      for (let i = 0; i < modalImageUrlList.length; i++){
          
            let fileName = modalImageUrlList[i].file_name;
            const result = await getFileOrigin(fileName); // blob
            const url = window.URL.createObjectURL(result);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'test');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    return (
      <>
        <NotebookTitleContainer>
          <nav className="notebook-title-info">
            <p>
              {detailNotebookOne.create_user_type === create_user_type_TEACHER ? "학부모님께" : "선생님께"}
            </p>
            {detailNotebookOne.create_user_type === create_user_type_TEACHER && (
              <RoundIcon
                text={changeNotebookType(detailNotebookOne.type)}
                type={`${detailNotebookOne.type === 1 ? "blue"
                  : detailNotebookOne.type === 2 ? "green"
                    : detailNotebookOne.type === 3 ? "orange"
                      : detailNotebookOne.type === 4 ? "yellow" : "gray" }`}
              />
            )}
          </nav>
          <div className="notebook-main-title">
            <p>{detailNotebookOne.title}</p>
          </div>
          <FlexWrapR $justifyContent="space-between" $gap="0" $alignItems="center" style={{flexWrap: 'wrap'}}>
            <p style={{width: '100%'}}>
              <span>{ellipsisText(detailNotebookOne.class_name, 12)}</span>
              <span> · </span>
              <span>{ellipsisText(detailNotebookOne.student_name, 12)}</span>
            </p>
            <span style={{ marginLeft: 'auto' }}>
              작성자(반): {aesCBCDecrypt(detailNotebookOne.user_name)}{detailNotebookOne.create_user_class_name ? `(${ellipsisText(detailNotebookOne.create_user_class_name, 15)})` : ""} </span>
            <span>/ 등록일자: {detailNotebookOne.reg_date.substring(0, detailNotebookOne.reg_date.length - 3)}</span>
          </FlexWrapR>
        </NotebookTitleContainer>

        <article className="content-container">
          {modalImageUrlList.length > 0 ? (
            <div>
              <ImageFileWrap>
                <img
                  src="/image/icon/arrow_left.svg"
                  alt="arrow-left"
                  className={`page-btn ${imageNum === 1 ? "disabled" : ""}`}
                  onClick={decreaseNum}
                />
                <div className="image-wrap" >
                  {modalImageUrlList.map((image: FileListType, index) => (
                    <div 
                      key={index}
                      className={index + 1 === imageNum ? "show" : ""}
                      style={{ position: 'relative' }}
                    >
                      <ImageContainer
                        ref={index + 1 === imageNum ? imageRef : null}
                        onMouseEnter={handleZoomEnter}
                        onMouseLeave={() => setShowZoom(false)}
                        onMouseMove={handleMouseMove}
                      >
                        <img
                          src={`${URL}/v1/sites/${selectSiteId}/file?file_name=${image.file_name}`}
                          alt={image.origin_file_name}
                        />
                        <ZoomFrame 
                          show={showZoom && index + 1 === imageNum}
                          x={zoomPosition.x}
                          y={zoomPosition.y}
                        />
                        <ZoomWindow
                          show={showZoom && index + 1 === imageNum}
                          x={zoomPosition.x}
                          y={zoomPosition.y}
                          dx={zoomPosition.dx}
                          dy={zoomPosition.dy}
                        >
                          <img
                            src={`${URL}/v1/sites/${selectSiteId}/file?file_name=${image.file_name}`}
                            alt={image.origin_file_name}
                          />
                        </ZoomWindow>
                      </ImageContainer>
                    </div>
                  ))}
                  <div className="pagination">
                    <p>
                      <span>{imageNum}</span>
                      <span> / {imageMaxNum}</span>
                    </p>
                  </div>
                </div>
                <img
                  src="/image/icon/arrow_right.svg"
                  alt="arrow-right"
                  className={`page-btn ${ imageNum === imageMaxNum ? "disabled" : "" }`}
                  onClick={increaseNum}
                />
              </ImageFileWrap>
              {/* <ImageFileWrap>
                <img
                  src="/image/icon/arrow_left.svg"
                  alt="arrow-left"
                  className={`page-btn ${imageNum === 1 ? "disabled" : ""}`}
                  onClick={decreaseNum}
                />
                <div className="image-wrap">
                  {modalImageUrlList.map((image: FileListType, index) => (
                    <div className={index + 1 === imageNum ? "show" : ""}>
                      <img
                        key={index}
                        src={`${URL}/v1/sites/${selectSiteId}/file?file_name=${image.file_name}`}
                        alt={image.origin_file_name}
                      />
                    </div>
                  ))}
                  <div className="pagination">
                    <p>
                      <span>{imageNum}</span>
                      <span> / {imageMaxNum}</span>
                    </p>
                  </div>
                </div>
                <img
                  src="/image/icon/arrow_right.svg"
                  alt="arrow-right"
                  className={`page-btn ${imageNum === imageMaxNum ? "disabled" : ""}`}
                  onClick={increaseNum}
                />
              </ImageFileWrap> */}
              <FlexWrapR $gap="1rem" $justifyContent="space-between" style={{marginTop: '0.5rem', textAlign: 'right', paddingRight: '1rem'}}>
                <SolidPrimarySubBtn onClick={() => downloadAllImage()}>전체 다운로드</SolidPrimarySubBtn>
                <SolidPrimarySubBtn onClick={() => downloadImage(imageNum)}>다운로드</SolidPrimarySubBtn>
              </FlexWrapR>
            </div>
          ) : null}
          {/* 앱에서는 문서 등록이 안되기때문에 웹은 주석처리 */}
          {/* {docUrlListRef.current.length ? (
            <DocFileWrap>
              <summary>
                <p>첨부파일 ({docMaxNum})</p>
              </summary>
              {docUrlListRef.current.map((doc: FileListType, index) => (
                <AttachFileWrap key={index} data-notebook-id={doc.notebook_id}>
                  <DocIcon className={(doc.mime_type).toLocaleLowerCase()} />
                  <EllipsisTextColumn>{doc.origin_file_name}</EllipsisTextColumn>
                  <div className="save-doc" onClick={() => downloadDoc(index)}>
                    <img src="/image/icon/save.svg" alt="close" />
                  </div>
                </AttachFileWrap>
              ))}
            </DocFileWrap>
          ) : null} */}
          <div className="content-text-wrap">
            <p>{detailNotebookOne.content}</p>
          </div>
        </article>
      </>
    )
  }

  /**
   * 알림장 상세보기 모달 - 수정/삭제
   * @returns 
   */
  const NotebookModalButton = (): JSX.Element => {

    const note = notebookList.find(n => n.id === notebookClickId);

    // 알림장 삭제 버튼
    async function handleDeleteNotebook(index: number) {

      if (!index) return;
      let isDelete = window.confirm("해당 알림장을 삭제하시겠습니까?");

      if (!isDelete) return;

      let result = await deleteNotebook(index);

      if (result.code === 200) {
        alert("알림장이 삭제되었습니다.");
        setModalProps({...modalProps, isOpen: false});
        mainApi();
      } else {
        alert(result.message);
        return;
      }
    }
    return (
      !note ? <></>
        : note.class_info && (!(user_role === ROLE_TEACHER && note.user_id !== user_id)) ?
          <InputWrapR $justifyContent="flex-end">
            <SolidPrimarySubBtn type="button" onClick={() => handlePutNotebook(notebookClickId, note)}>
              수정
            </SolidPrimarySubBtn>
            <SolidRedBtn type="button" onClick={() => handleDeleteNotebook(notebookClickId)}>
              삭제
            </SolidRedBtn>
          </InputWrapR>
          : <></>
    )
  }

  // *************************************** API

  /**
   * 담당 class 가져오기
   */
  const getClassList = useCallback(async () => {
    try {
      setLoading(true);

      // 담당반 클래스 아이디 리스트 업데이트
      const classQueryParams: ClassQueryParams = {
        name: "",
        user_id: user_role === ROLE_DIRECTOR ? 0 : user_id,
        response_format: "",
        page: 1,
        size: 99999999
      };
  
      const classResult: ListResult<ClassInfo> = await getClass(classQueryParams);
  
      // 반 정보가 없는 경우
      if (classResult.code !== 200 || (classResult.code === 200 && classResult.data.length === 0)) {
        setClassList([]);
        setClassSelectOption([]);
      }
      else {
        const userClassList: ClassInfo[] = classResult.data;
        setClassList(userClassList);
        
        const _classSelectOption = userClassSelectOption(userClassList, user_role);
        setClassSelectOption(_classSelectOption);
  
        if (user_role === ROLE_DIRECTOR) {
          const _classId = classFilter ? Number(classFilter) : 0;
          setNotebookQueryParams(prev => ({ ...prev, class_id: _classId }));
          setClassId(0);
        }
        else if (user_role === ROLE_TEACHER) {
          const _classId = userClassList.length ? userClassList[0].id : -1;
  
          setNotebookQueryParams(prev => ({ ...prev, class_id: _classId }));
          setClassId(_classId);
        }
      }
  
      // 알림장 관련 초기화
      setNotebookList([]);
      setToParentNotebookList([]);
      setTotalCountToParent(0);

    } catch (error) {
      console.error('error ', error);
    }
  
  }, [user_role, user_id, classFilter]);

  /**
   * 알림장 가져오기
   */
  const mainApi = useCallback (async () => {
    try {

      setLoading(true);
      const result: ListResult<NotebookInfo> = await getNotebook(notebookQueryParams);
      
      // 처음 알림장 메뉴 클릭 시 누구에게 작성하는지 type 구분
      // create_user_type 작성자의 권한 구분: 0 기본값 1 선생님 2 학부모
      if (notebookQueryParams.create_user_type === 0) {
        if (result.code === 200) {
          
          setNotebookList(result.data);
          const toTeacherData = result.data.filter((_list: NotebookInfo) =>
            _list.create_user_type === create_user_type_PARENT
          );

          const toParentData = (result.data.filter((_list: NotebookInfo) =>
            _list.create_user_type === create_user_type_TEACHER
          ));
        
          setToTeacherNotebookList(toTeacherData);
          setTotalCountToTeacher(toTeacherData.length);
  
          setToParentNotebookList(toParentData);
          setTotalCountToParent(toParentData.length);
        }
        else {
          setNotebookList([]);
          setToTeacherNotebookList([]);
          setTotalCountToTeacher(0);
          setToParentNotebookList([]);
          setTotalCountToParent(0);
          alert(result.message);
        }
      }
      
      // ** 현재는 선생님께/학부모님께 탭 없앰
      
      // 선생님 -> 학부모: 작성자가 선생님인 경우
      else if (notebookQueryParams.create_user_type === 1) {
        if (result.code === 200) {

          const toParentData = result.data;

          setToParentNotebookList(toParentData);
          setTotalCountToParent(toParentData.length);
        }
        else {
          setToParentNotebookList([]);
          setTotalCountToParent(0);
          alert(result.message);
        }
      }
      // 학부모 -> 선생님: 작성자가 학부모인 경우
      else if(notebookQueryParams.create_user_type === 2){
        if (result.code === 200) {
          setToTeacherNotebookList(result.data);
          setTotalCountToTeacher(result.data.length);
        }
        else {
          setToTeacherNotebookList([]);
          setTotalCountToTeacher(0);
          alert(result.message);
        }
      }

      setLoading(false);

    } catch (error) {
      console.error("API error ", error);
    }
  }, [notebookQueryParams]);

  // *************************************** useEffect

  /**
   * * 필터 설정이 된 상태에서 작성/수정 후 다시 돌아왔을 때 설정해둔 필터를 보여주기 위함
   * student는 class가 먼저 선택되어야 select-option이 보이기 때문에
   * 이전 사용자가 class/student를 선택해놨다면 아래 useEffect 실행
   * class만 선택했다면 미실행
   */
  useEffect(() => {
    // 관리자인 경우
    if (user_role === ROLE_DIRECTOR) {
      // 반이 없거나, classFilter가 없는 경우
      if (!classList.length || !classFilter) return;

      // classFilter가 있는 경우
      const studentList = userClassStudentSelectOption(classList, Number(classFilter));
      if (studentList.length) {
        setStudentSelectOption(studentList);
      }
      
    }
    // 선생님인 경우
    if (user_role === ROLE_TEACHER && classList.length) {
      // 담당반 있음
      const studentList = userClassStudentSelectOption(classList, -1);
      if (studentList.length) {
        setStudentSelectOption(studentList);
      }

    }

    // 학생 필터가 걸려있는 경우
    if (studentFilter) {
      const studentList = userClassStudentSelectOption(classList, Number(classFilter));
      if (studentList.length) {
        setStudentSelectOption(studentList);
      }

    }
  }, [classList, classFilter, studentFilter, user_role]);
  
  useEffect(() => {
    getClassList();
  }, [getClassList]);

  useEffect(() => {
    if (classId !== -1) {
      mainApi();
    }
    else setLoading(false);
  }, [classId, mainApi]);

  return (
    <>
      {loading ? <Loading />
      :
        <>
          <PageHeaderTitleButtonStyle>
            <p className="header-title">알림장</p>
            <div className="button-wrap">
              <SolidPrimaryBtn onClick={() => handleCreateNotebook()} disabled={!classList.length || (user_role === ROLE_TEACHER && !studentSelectOption.length)} >
                신규 작성
              </SolidPrimaryBtn>
            </div>
          </PageHeaderTitleButtonStyle>
          <PageArticleWrap>
            <nav className="filter-container">
              <div className="filter-wrap">
                <label>반</label>
                {user_role === ROLE_DIRECTOR ?
                  <SelectOption
                    optionData={classSelectOption}
                    defaultValue={Number(classFilter) || 0}
                    onChange={(prop: number) => handleClassSelectOptions(prop)}
                  />
                  :
                  <SelectOption
                    optionData={classSelectOption}
                    defaultValue={Number(classSelectOption[0]?.value)}
                    onChange={(prop: number) => handleClassSelectOptions(prop)}
                    placeholderText={!classSelectOption.length ? "담당반 없음" : ""}
                    dontChange
                  />
                }
              </div>
              <div className="filter-wrap">
                <label>학생</label>
                {user_role === ROLE_TEACHER && !classList.length ? 
                  <input value={"담당반을 먼저 지정해주세요"} disabled style={{ height: 'auto' }} />
                  : notebookQueryParams.class_id && !studentSelectOption.length ? // 등록된 반은 있지만 해당 반에 학생이 없는 경우
                    <input value={"등록된 학생이 없어요."} disabled style={{ height: 'auto' }} />
                  : <SelectOption
                    optionData={studentSelectOption}
                    defaultValue={Number(studentFilter) || 0}
                    onChange={(prop: number) => handleStudentSelectOptions(prop)}
                    placeholderText={ user_role === ROLE_DIRECTOR ? "반을 먼저 선택해주세요." : "학생을 선택해주세요"}
                  />
                }
              </div>
              <CustomDatePickerWrap className="custom-date-picker">
                <label>작성일</label>
                <ReactDatePicker
                  locale={ko}
                  enableTabLoop={false}
                  dateFormat="yyyy-MM-dd (E)" // 날짜형태
                  // formatWeekDay={(day) => day.substring(0, 1)} // 요일이 Su Mo Tu가 아닌 S M T 형태로 나타냄
                  shouldCloseOnSelect // 날짜 선택 시 datepicker 자동 닫힘
                  todayButton="오늘"
                  selected={startDate}
                  onChange={handleSearchStartDate}
                  dropdownMode="select"
                  minDate={new Date(`${CURRENTYEAR - 3}-01-01`)}
                  maxDate={new Date()}
                  dayClassName={(d) => getDayClassName(d, startDate, holidayList)}
                  renderCustomHeader={({
                    date,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }) => (
                    <div className="custom-header-container">
                      <div>
                        <button
                          type="button"
                          onClick={decreaseMonth}
                          className="custom-month-button"
                          disabled={prevMonthButtonDisabled}
                        >
                          <img src="/image/icon/arrow_left.svg" alt="left" />
                        </button>
                        <span className="custom-year">{getYear(date)}</span>
                        <select
                          value={months[getMonth(date)]}
                          className="custom-month"
                          onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
                        >
                          {months.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                        <button
                          type="button"
                          onClick={increaseMonth}
                          className="custom-month-button"
                          disabled={nextMonthButtonDisabled}
                        >
                          <img src="/image/icon/arrow_right.svg" alt="right" />
                        </button>
                      </div>
                    </div>
                  )}
                />
              </CustomDatePickerWrap>
              <OutlinePrimaryBtn type="button" className="little-btn contain-icon" onClick={resetFilter}>
                <img srcSet={refreshIcon} alt="refresh"/>
              </OutlinePrimaryBtn>
            </nav>
            <article className="list-content-container">
              <div className="article-header">
                <p>
                  <span className="article-header-title">알림장 목록({notebookList.length})</span>
                </p>
              </div>
              <div className="join-wrap">
                {/* <NotebookTypeWrap>
                  <button
                    type="button"
                    className={`text-btn ${ activeMenu === "toTeacher" ? "active" : "" }`}
                    onClick={() => handleJoinType("toTeacher")}
                  >
                    <p>선생님께</p>
                    <p className="note-count">{totalCountToTeacher}</p>
                  </button>
                  <button
                    type="button"
                    className={`text-btn ${ activeMenu === "toParent" ? "active" : "" }`}
                    onClick={() => handleJoinType("toParent")}
                  >
                    <p>학부모님께</p>
                    <p className="note-count">{totalCountToParent}</p>
                  </button>
                </NotebookTypeWrap> */}
                  <NotebookOneWrap>
                    {/* {activeMenu === "toTeacher" && (
                      totalCountToTeacher === 0 ? <NoDataWithImageText text={NoNotebookDataToTeacherText} />
                      : (
                        <div className="list-table">
                          <div>
                            <nav className="list-table-header">
                              <div className="w-10">이미지</div>
                              <div className="w-12">알림 일자</div>
                              <EllipsisTextColumn className="w-12">작성자</EllipsisTextColumn>
                              <EllipsisTextColumn className="w-12">반이름</EllipsisTextColumn>
                              <EllipsisTextColumn className="w-12">원생 이름</EllipsisTextColumn>
                              <EllipsisTextColumn className="w-20">제목</EllipsisTextColumn>
                            </nav>
                            {toTeacherNotebookList.map((note, index) => (
                              <NotebookOne
                                key={index}
                                onClick={() => {openModal('showNotebook');changeRequestNotebookHandler(note.id, note)}}
                              >
                                <div className="w-10 thumbnail-wrap">
                                  {(() => {
                                    let mainImg: any = note.file_list.find((file: any) =>
                                      file.mime_type === "jpg" || file.mime_type === "png" || file.mime_type === "jpeg"
                                    );
                                    return mainImg ? (
                                      <img
                                        src={`${URL}/v1/sites/${note.site_id}/file?file_name=${mainImg.file_name}`}
                                        alt={mainImg.origin_file_name}
                                      />
                                    ) : <ErrorImage />;
                                  })()}
                                </div>
                                <div className="w-12">
                                  <p>{note.note_date}</p>
                                </div>
                                <EllipsisTextColumn className="w-12">
                                <p>
                                  {aesCBCDecrypt(note.user_name)}
                                </p>
                                </EllipsisTextColumn>
                                <EllipsisTextColumn className="w-12">
                                  <p>{note.class_info.name}</p>
                                </EllipsisTextColumn>
                                <EllipsisTextColumn className="w-12">
                                <p>
                                  {aesCBCDecrypt(note.student_info.name)}
                                </p>
                                </EllipsisTextColumn>
                                <EllipsisTextColumn className="w-20">
                                  <p>{note.title}</p>
                                </EllipsisTextColumn>
                              </NotebookOne>
                            ))}
                          </div>
                        </div>
                      )
                    )} */}
                    { user_role === ROLE_DIRECTOR && classList.length === 0 ? // 관리자 - 등록된 반이 없는 경우
                      <NoDataWithImageText text={NoClassDataText} />
                      : user_role === ROLE_TEACHER && classList.length === 0 ? // 선생님 - 담당하는 반이 없는 경우
                      <NoDataWithImageText text={NoTeamClassDataText} />
                      : user_role === ROLE_TEACHER && !studentSelectOption.length ? // 선생님 - 담당반에 학생이 없는 경우
                        <NoDataWithImageText text={NoStudentDataText} />
                      : totalCountToParent === 0 ? // 반이 있는데 알림장이 없는 경우
                        <NoDataWithImageTextButton
                          text={NoNotebookDataToParentText}
                          btnText="신규 알림장 등록"
                          linkUrl="/notebook/write"
                        />
                        : (
                        <div className="list-table">
                          <div>
                            <nav className="list-table-header">
                              <div className="w-10">이미지</div>
                              <div className="w-12">작성일</div>
                              <div className="w-8">카테고리</div>
                              <FlexGrow className="w-12">작성자(반)</FlexGrow>
                              <FlexGrow className="w-12">반이름</FlexGrow>
                              <FlexGrow className="w-12">학생 이름</FlexGrow>
                              <FlexGrow className="w-20">제목</FlexGrow>
                              <div className="w-10">비고</div>
                            </nav>
                            {toParentNotebookList.map((note, index) => (
                              <NotebookOne
                                key={index}
                                onClick={() => {openModal('showNotebook');changeRequestNotebookHandler(note.id, note)}}
                              >
                                <div className="w-10 thumbnail-wrap">
                                  {(() => {
                                    let mainImg: any = note.file_list.find((file: any) =>
                                      file.mime_type === "jpg" || file.mime_type === "png" || file.mime_type === "jpeg"
                                    );
                                    return mainImg ? (
                                      <img
                                        src={`${URL}/v1/sites/${note.site_id}/file?file_name=${mainImg.file_name}`}
                                        alt={mainImg.origin_file_name}
                                      />
                                    ) : <ErrorImage />;
                                  })()}
                                </div>
                                <div className="w-12">
                                  <p>{note.note_date}</p>
                                </div>
                                <div
                                  className={`w-8 ${note.type === 1 ? "text-blue"
                                    : note.type === 2 ? "text-green"
                                      : note.type === 3 ? "text-vermillion"
                                        : note.type === 4 ? "text-yellow" : "text-gray" }`}
                                >
                                  <p>{changeNotebookType(note.type)}</p>
                                </div>
                                <FlexGrow className="w-12">
                                  <EllipsisTextColumn>{`${aesCBCDecrypt(note.user_name) || "-"}`}{`${note.create_user_class_name ? `(${note.create_user_class_name})` : ""}`}</EllipsisTextColumn>
                                </FlexGrow>
                                <FlexGrow className="w-12">
                                  <EllipsisTextColumn>{note.class_info ? note.class_info.name : "반 미정"}</EllipsisTextColumn>
                                </FlexGrow>
                                <FlexGrow className="w-12">
                                  <EllipsisTextColumn>{aesCBCDecrypt(note.student_info.name)}</EllipsisTextColumn>
                                </FlexGrow>
                                <FlexGrow className="w-20">
                                  <EllipsisTextColumn>{note.title}</EllipsisTextColumn>
                                </FlexGrow>
                                <div className="w-10">
                                  <OutlinePrimaryBtn type="button" onClick={() => handlePutNotebook(note.id, note)}
                                    disabled={(user_role === ROLE_TEACHER && note.user_id !== user_id) || !note.class_info} >
                                    수정하기
                                  </OutlinePrimaryBtn>
                                </div>
                              </NotebookOne>
                            ))}
                          </div>
                        </div>
                      )
                    }
                </NotebookOneWrap>
              </div>
            </article>
          </PageArticleWrap>
        </>
      }
      {/*content에 렌더링할 컴포넌트를 전달하여 최신 상태로 리렌더링*/}
      <DefaultModalComponent isOpen={modalProps.isOpen}
                            content={NotebookModalContent()}
                            button={NotebookModalButton()}
                            type={modalProps.type}
                            isClose={modalProps.isClose}
                            title={modalProps.title} />
    </>
  );
}

export function Notebook() {
  const [classFilter, setClassFilter] = useState('');
  const [studentFilter, setStudentFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  return (
    <>
      <Outlet context={{ classFilter, setClassFilter, studentFilter, setStudentFilter, dateFilter, setDateFilter }} />
    </>
  );
}
